import { OrganizationListPage } from "../organization/organization-list-page"

export const OrganizationsPage = () => {
  return <OrganizationListPage />
}
